import { render } from "./EventCard.vue?vue&type=template&id=13250162&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=13250162&scoped=true&lang=css"

import exportComponent from "D:\\JotaDev\\Vue\\VueMastery\\Real-World_Vue-3\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13250162"]])

export default __exports__